/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useContext, useState } from 'react';
import styles from './styles.module.css';
import statusStyles from '../../styles.module.css';
import { useTranslation, withTranslation } from 'react-i18next';
import { DownOutlined } from '@ant-design/icons';
import SignalStrengthOvertimeByDevice from '../../../../../../../../../public/images/SignalStrengthOvertimeByDevice.png';
import NoAccessDescriptionModal from '../../../../../../components/NoAccessDescriptionModal';
import { Alert, Dropdown, Menu } from 'antd';
import ConfigContext from '../../../../../../../../components/ConfigContext';

const getItem = (label, key, icon, children, type) => {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
};

export const Status = props => {
  const { status, deviceIdentifier, connectionType } = props;
  let style;
  const { t } = useTranslation();
  const { config } = useContext(ConfigContext);
  const [advancedItem, setAdvancedItem] = useState({
    isViewNoAccessModal: false,
  });

  const handleAdvancedMenuClick = event => {
    const menuKey = event.key;
    let title;
    let content;
    let imgSrc;
    let redirectPage;

    switch (menuKey) {
      case 'signal':
        redirectPage =
          window.location.origin +
          `/${config.appName}/analytics/device-connectivity/signal-strength-by-device?` +
          `deviceId=${deviceIdentifier}&connectionType=${connectionType}`;
        title = t('label_signalStrengthOvertimeByDevice');
        imgSrc = SignalStrengthOvertimeByDevice;
        content = (
          <div>
            <Alert
              message={t('analytic_warningTxt1', {
                label: t('label_signalStrengthOvertimeByDevice'),
              })}
              type="warning"
            />
          </div>
        );
        break;
    }

    if (config.analyticEnabledDomains.includes(config.userDomain)) {
      window.open(redirectPage, '_blank');
    } else {
      setAdvancedItem({
        title: title,
        imgSrc: imgSrc,
        content: content,
        isViewNoAccessModal: true,
      });
    }
  };

  const onCloseAdvancedNoAccessModal = () => {
    setAdvancedItem({
      isViewNoAccessModal: false,
    });
  };

  const items = [getItem(t('label_signalStrengthOvertimeByDevice'), 'signal')];

  const menu = <Menu onClick={e => handleAdvancedMenuClick(e)} items={items} />;

  switch (status) {
    case 'ACTIVE':
      style = statusStyles.success;
      break;
    case 'INACTIVE':
      style = statusStyles.warning;
      break;
    case 'REMOVED':
      style = statusStyles.danger;
      break;
    case 'UNREACHABLE':
      style = statusStyles.unreachable;
  }
  return (
    <div className={`${styles.container} ${style}`}>
      <div>{t('label_status')}</div>
      {props.status !== ('INACTIVE' || 'UNREACHABLE') && (
        <div className={styles.value}>
          {t('label_uppercase_string', {
            label: t(`label_${props.status.toLowerCase()}`),
          })}
        </div>
      )}
      {props.status === ('INACTIVE' || 'UNREACHABLE') && (
        <Dropdown overlay={menu} trigger={['click']}>
          <a className={styles.status} onClick={e => e.preventDefault()}>
            {t('label_uppercase_string', {
              label: t(`label_${props.status.toLowerCase()}`),
            })}{' '}
            <DownOutlined style={{ fontsize: '1.1vw' }} />
          </a>
        </Dropdown>
      )}
      {!config.analyticEnabledDomains.includes(config.userDomain) &&
        advancedItem.isViewNoAccessModal && (
          <div>
            <NoAccessDescriptionModal
              title={advancedItem.title}
              content={advancedItem.content}
              imgSrc={advancedItem.imgSrc}
              isModalView={advancedItem.isViewNoAccessModal}
              onCloseAdvancedNoAccessModal={onCloseAdvancedNoAccessModal}
            />
          </div>
        )}
    </div>
  );
};

export default withTranslation()(Status);
